// CalendlyPixelBridge.js
import { useEffect } from 'react';

export default function CalendlyPixelBridge() {
  useEffect(() => {
    const h = e => {
      if (e?.data?.event === 'calendly.event_scheduled') {
        window.fbq('track', 'Schedule');        // or custom name
      }
    };
    window.addEventListener('message', h);
    return () => window.removeEventListener('message', h);
  }, []);
  return null;
}